import { useEffect, useState } from "react";
import { authData, withAdminAuth } from "../../../components/GetAuth";
import styles from "./containerreports.module.css";
import { TableLoader } from "../../../components/ContentLoader";
import { Calendar, Eye, Home, Search, X } from "react-feather";
import { Button, Dialog, DialogContent, DialogTitle, Paper, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TableRow, TextField } from "@mui/material";
import { Close } from "@mui/icons-material";
import { DateRangePicker } from "rsuite";
import { StyledMainTableCell, StyledMainTableRow } from "../../../components/TableComponent";
import TablePaginationComponent from "../../../components/TablePagination";
import axios from "axios";
import dayjs from "dayjs";
import { CurrencyFormatter } from "../../../components/Helpers";
import { Link } from "react-router-dom";

const ContainerReportDetails = ({ containerId }) => {
    const auth = authData();
    const API_TOKEN = auth?.api_token;
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const [allData, setAllData] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [contentLoading, setContentLoading] = useState(true);
    const [viewModalOpen, setViewModalOpen] = useState(false);
    const [selectedContainer, setSelectedContainer] = useState(null);

    const paginationChangePage = (event, newPage) => {
        setPage(newPage);
    }

    const paginationChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    }

    useEffect(() => {
        fetchOrders();
    }, [page, rowsPerPage]);

    const fetchOrders = () => {
        axios.get(process.env.REACT_APP_API_URL + "v1/report/container-report/" + containerId, {
            headers: {
                Authorization: `Bearer ${API_TOKEN}`,
            },
            params: {
                page: page + 1,
                per_page: rowsPerPage
            }
        }).then((response) => {
            setContentLoading(false);

            setAllData(response.data.data.data);
            setTotalCount(response.data.data.total);
        }).catch(() => {
            setContentLoading(false);
        });
    }

    return (<>
        {contentLoading && <TableLoader />}

        {!contentLoading && (<>

            <div className="CusTable">
                <TableContainer component={Paper} style={{ padding: 0, marginTop: '20px' }}>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <StyledMainTableCell>Booking Id</StyledMainTableCell>
                                <StyledMainTableCell>Customer Name</StyledMainTableCell>
                                <StyledMainTableCell>Order Date</StyledMainTableCell>
                                <StyledMainTableCell>Total Amount</StyledMainTableCell>
                                <StyledMainTableCell>Paid Amount</StyledMainTableCell>
                                <StyledMainTableCell>Due Balance</StyledMainTableCell>
                                <StyledMainTableCell>Order Status</StyledMainTableCell>
                                <StyledMainTableCell>Pickup Post Code</StyledMainTableCell>
                                <StyledMainTableCell>Pickup Date</StyledMainTableCell>
                                <StyledMainTableCell>Created User</StyledMainTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {allData.map((item, index) => {
                                return (<StyledMainTableRow key={index} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                                    <TableCell component="th" scope="row">{item?.booking_id}</TableCell>
                                    <TableCell component="th" scope="row">{item?.customer_name}</TableCell>
                                    <TableCell component="th" scope="row">{dayjs(item?.created_at).format("DD/MM/YYYY")}</TableCell>
                                    <TableCell component="th" scope="row">{CurrencyFormatter(parseFloat(item?.total))}</TableCell>
                                    <TableCell component="th" scope="row">{CurrencyFormatter(parseFloat(item?.paid_amount))}</TableCell>
                                    <TableCell component="th" scope="row">{CurrencyFormatter(parseFloat(item?.due_balance))}</TableCell>
                                    <TableCell component="th" scope="row">
                                        {(parseInt(item?.payment_status) === 1 ? (<button style={{ color: '#FFF', padding: '5px 10px', textDecoration: 'none', background: '#002962', borderRadius: '6px', fontSize: '13px', fontWeight: 500, margin: 0, }}>Paid</button>) : (<button style={{ color: '#fff !important', padding: '5px 10px', textDecoration: 'none', background: '#ff002b', borderRadius: '6px', fontSize: '13px', fontWeight: 500, margin: 0, }}>Unpaid</button>))}
                                    </TableCell>
                                    <TableCell component="th" scope="row">{item?.post_code}</TableCell>
                                    <TableCell component="th" scope="row">{dayjs(item?.pickup_date).format("DD/MM/YYYY")}</TableCell>
                                    <TableCell component="th" scope="row">{item?.created_user}</TableCell>
                                </StyledMainTableRow>);
                            })}

                            {allData.length === 0 && (<TableRow>
                                <TableCell colSpan={6} align="center">No data found</TableCell>
                            </TableRow>)}

                        </TableBody>
                        {totalCount > 0 && (<TableFooter>
                            <TableRow>
                                <TablePaginationComponent
                                    count={totalCount}
                                    colSpan={6}
                                    page={page}
                                    rowsPerPage={rowsPerPage}
                                    handleChangePage={paginationChangePage}
                                    handleChangeRowsPerPage={paginationChangeRowsPerPage}
                                />
                            </TableRow>
                        </TableFooter>
                        )}
                    </Table>
                </TableContainer>
            </div>
        </>)
        }
    </>);
};

export default ContainerReportDetails;